export const getKinescopeVideoId = ({ url }: { url: string }): string | null => {
    if (url.includes('kinescope')) {
        const splitedUrl = url.split('/');
        return splitedUrl[splitedUrl.length - 1];
    }
    return null;
};
